module.exports = __webpack_public_path__ + "i18n/nl.7f53b528434edafc6ebd7d022b74a3e0.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 852
// module chunks = 60